<template>
  <div class="xd-information-form">
      <div class="textarea-main">
          <div class="title">{{$route.query.title}}：<span>{{place}}</span></div>
          <textarea  v-model="text" ></textarea>
      </div>
        <!--  -->
      <div class="footer">
          <button @click="saveHandle()">保存</button>
      </div>
  </div>
</template>

<script>
import { getSessionStorage, setSessionStorage} from '@/utils/tools'
export default {
    data(){
        return{
            place:'',
            text:''
        }
    },
    methods:{
        // 提交填写数据
        saveHandle(){
            let q = this.$route.query;
            if(q.title=='公司名称'){
                setSessionStorage('/xd_add_experience','corporate_name',this.text);
            }
            if(q.title=='职业类型'){
                setSessionStorage('/xd_add_experience','profession',this.text);
            }
            if(q.title=='所在行业'){
                setSessionStorage('/xd_add_experience','industry',this.text);
            }
            if(q.title=='工作内容'){
                setSessionStorage('/xd_add_experience','job_content',this.text);
            }
            
            this.$router.go(-1);
        },
        // 初始化获取数据
        pullData(){
            let q = this.$route.query;
            document.title = q.title;
            this.place = '请填写'+q.title;
            if(q.title=='公司名称' && getSessionStorage('/xd_add_experience','corporate_name')){
                this.text = getSessionStorage('/xd_add_experience','corporate_name');
            }
            if(q.title=='职业类型' && getSessionStorage('/xd_add_experience','profession')){
                this.text = getSessionStorage('/xd_add_experience','profession');
            }
            if(q.title=='所在行业' && getSessionStorage('/xd_add_experience','industry')){
                this.text = getSessionStorage('/xd_add_experience','industry');
            }
            if(q.title=='工作内容' && getSessionStorage('/xd_add_experience','job_content')){
                this.text = getSessionStorage('/xd_add_experience','job_content');
            }

            
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #F7F8F9;
    }
</style>
<style lang="scss" scoped>
    .xd-information-form{
        padding: 20px 30px 140px;
        .textarea-main{
            font-size: 30px;
            min-height: 300px;
            background: #FFFFFF;
            border-radius: 20px;
            position: relative;
            padding: 36px 30px;
            .title{
                font-weight: bold;
                color: #2B333A;
                font-size: 30px;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                span{
                    font-size: 24px;
                    color: #A9AFB3;
                    font-weight: 400;
                }
            }
            textarea{
                width: 100%;
                min-height: 700px;
                font-size: 30px;
                outline: none;
                resize: none;
                border: none;
                background: transparent;
            }
        }
        .footer{
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            max-width: 750px;
            background-color: #FFFFFF;
            button{
                width: 670px;
                height: 80px;
                background: #46A3FA;
                border-radius: 40px;
                font-size: 32px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 44px;
                letter-spacing: 1px;
                border: none;
            }
        }
    }
</style>